<template>
    <div id="workflow-permission">
        <supsis-table
            :columns="cols"
            :rows="getFilteredRows()"
            :bottom-pagination="true"
            :pagination-cursor="paginationCursor || 10"
            :options="tableOptions"
            @cursor-changed="(cursor) => (paginationCursor = cursor)"
            class="users-supsis-table"
        >
            <template #header>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <a-input-search
                            :value="searchText"
                            @input="searchTextHandle($event)"
                            :placeholder="$t('message.startFilter')"
                            class="search-input"
                            @search="onSearch"
                        />
                    </div>
                </div>
            </template>
        </supsis-table>

        <Modal2
            v-if="isModalShow"
            :title="$t('task.userPerm')  + selectedUser.name"
            :show-footer="false"
            @cancel="hideModal"
            style="width: 400px;"
            :class-name="'modal2'"
        >
            <div class="permissions-container">
                <div class="checkbox-group" style="display:grid; gap:10px">
                    <label>
                        <input type="checkbox" :checked="form.permissions.deleteTask.includes(selectedUser._id)"
                               @change="togglePermission('deleteTask', selectedUser._id)" /> {{ $t("task.deleteCard") }}
                    </label>
                    <label>
                        <input type="checkbox" :checked="form.permissions.createTask.includes(selectedUser._id)"
                               @change="togglePermission('createTask', selectedUser._id)" /> {{ $t("task.createCard") }}
                    </label>
                    <label>
                        <input type="checkbox" :checked="form.permissions.editTask.includes(selectedUser._id)"
                               @change="togglePermission('editTask', selectedUser._id)" /> {{ $t("task.editCard") }}
                    </label>
                    <label>
                        <input type="checkbox" :checked="form.permissions.draggingTask.includes(selectedUser._id)"
                               @change="togglePermission('draggingTask', selectedUser._id)" /> {{ $t("task.dragCard") }}
                    </label>
                </div>
                <div style="display: flex; justify-content: space-around;">
                    <SupsisButton @click="hideModal" style="margin-top: 20px; cursor:pointer">
                        {{ $t("search.cancelBtn") }}
                    </SupsisButton>
                    <SupsisButton @click="handleSave" style="margin-top: 20px; cursor:pointer">
                        {{ $t("message.save") }}
                    </SupsisButton>
                </div>
            </div>
        </Modal2>

    </div>
</template>

<script>
import SupsisTable from "../SupsisTable.vue";
import SupsisButton from "../../views/Pages/Settings/components/SupsisButton.vue";
import AgentAvatar from "../common/AgentAvatar.vue";
import ActionEdit from "../svg/ActionEdit.vue";
import Modal2 from "../common/Modal2.vue";
import * as _ from "lodash";
import { mapActions, mapGetters, mapState } from "vuex";


export default {
    name: "PermissionWorkflow",
    props: {
        details: {
            type: Object,
        },
    },
    components: {
        ActionEdit,
        SupsisButton,
        SupsisTable,
        Modal2,
        AgentAvatar,
    },
    data() {
        return {
            searchText: "",
            submitClicked: false,
            editMode: false,
            switchButton: true,
            paginationCursor: {
                total: 0,
                page: 1,
                perPage: 10,
            },
            tableOptions: {
                id: "users-table",
                scrollWidth: "1000px",
                rowStyleOption: {
                    stripe: true,
                },
                eventCustomOption: {
                    bodyCellEvents: () => {
                        return {
                            dblclick: (event) => {
                                const columnIndex = event.target.cellIndex;
                                const column = this.cols[columnIndex];
                                if (!column || column.copyDisabled) {
                                    return;
                                }

                                let text = event.toElement.innerText;
                                let textArea = document.createElement("textarea");
                                textArea.value = text;
                                document.body.appendChild(textArea);
                                textArea.select();
                                document.execCommand("copy");
                                document.body.removeChild(textArea);
                                this.$message.success({
                                    content: this.$t("message.copiedClipboard"),
                                    duration: 2,
                                    key: "saved",
                                });
                            },
                        };
                    },
                },
            },
            users: {
                total: 0,
                count: 0,
                data: [],
            },
            user: {
                _id: null,
                name: "",
                email: "",
                password: "",
                role: undefined,
                subjects: [],
                autoAssignLimit: -1,
                enable: true,
                lang: "tr",
            },
            passwordConfirmation: "",
            selectedDepartments: [],
            isModalShow: false,
            currentSort: {
                columnKey: this.$route.query.columnKey || "name",
                order: this.$route.query.order || "ascend",
            },
            permissions: {
                deleteTask: false,
                editTask: false,
                createTask: false,
                draggingTask: false,
            },
            form: {
                permissions: {
                    deleteTask: [],
                    editTask: [],
                    createTask: [],
                    draggingTask: [],
                },
            },
            selectedUser: {},
        };
    },
    computed: {
        ...mapState({
            roles: (state) => state.role.roles,
            subjects: (state) => state.subject.subjects.data,
            loggedUser: (state) => state.auth.user || state.auth.adminUser,
            activeUserCount: (state) => state.user.activeUserCount,
            workflows: (state) => state.tasks.workflows,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        cols() {
            return [
                {
                    field: "Avatar",
                    key: "avatar",
                    title: "",
                    width: 50,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(AgentAvatar, {
                            props: {
                                userID: row._id,
                                size: 30,
                                isNamed: false,
                            },
                        });
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: this.$t("message.username"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.name.length > 15 ? row.name.slice(0, 11) + "..." : row.name;
                    },
                },
                {
                    field: "email",
                    key: "email",
                    title: this.$t("message.email"),
                },
                {
                    field: "roleSlot",
                    key: "roleSlot",
                    title: this.$t("message.role"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.role ? row.role.name : "-";
                    },
                },
                {
                    field: "subjects",
                    key: "subjects",
                    title: this.$t("message.departments"),
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const names = this.getUserDepartmentNames(row);
                        return (
                            <div
                                v-tippy={{
                                    followCursor: true,
                                    placement: "top-right",
                                    theme: this.isDarkMode ? "light-border" : "google",
                                }}
                                content={names}
                            >
                                {names}
                            </div>
                        );
                    },
                },
                {
                    align: "right",
                    field: "actionsSlot",
                    key: "actionsSlot",
                    copyDisabled: true,
                    title: this.$t("message.transactions"),
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const renderEditButton = () => {
                            return (
                                <a-button
                                    class="actionButton d-flex align-items-center"
                                    on-click={() => this.edit(row)}
                                >
                                    <ActionEdit />
                                </a-button>
                            );
                        };
                        return (
                            <div class="d-flex w-100 justify-content-end">
                                {renderEditButton()}
                            </div>
                        );
                    },
                },
            ];
        },
    },
    methods: {
        ...mapActions({
            getUser: "user/getUser",
            getUsers: "user/getUsers",
            getRoles: "role/getRoles",
            createUser: "user/createUser",
            updateUser: "user/updateUser",
            deleteUser: "user/deleteUser",
            getActiveUserCount: "user/getActiveUserCount",
            updateWorkflow: "tasks/updateWorkflow",
        }),
        getFilteredRows() {
            const getWorkflow = this.workflows.find(workflow => workflow.id === this.details.workflowId);
            const users = this.users.data;
            const userId = this.user_id;

            if (!getWorkflow) {
                return [];
            }

            const visibleUsers = getWorkflow.visibility.users;

            if (visibleUsers.length > 0) {
                return users.filter(user => visibleUsers.includes(user._id));
            } else {
                return users;
            }
        },
        tableChange(pagination, filters, sorter) {
            this.paginationCursor.perPage = pagination.pageSize;
            const newSort = {
                columnKey: sorter.columnKey,
                order: sorter.order,
            };
            const oldSort = this.currentSort;
            if (!_.isEqual(newSort, oldSort)) {
                this.currentSort = newSort;
                this.renderCount += 1;
                this.$forceUpdate();
            }
        },
        pageChange(page, pageSize) {
            this.paginationCursor.page = page;
            this.paginationCursor.perPage = pageSize;
        },
        searchTextHandle(e) {
            this.searchText = e.target.value;
        },
        onSearch() {
            this.debouncedGet(false, true, 0);
        },
        getUserDepartmentNames(user) {
            return (user.subjects || []).length
                ? this.subjects
                    .filter((x) => (user.subjects || []).includes(x._id))
                    .map(
                        (x) =>
                            _.get(x, `languageContent.${this.$i18n.locale}.name`) ||
                            _.get(x, `languageContent.${Object.keys(x.languageContent)[0]}.name`),
                    )
                    .join(",")
                    .toLowerCase()
                : this.$t("message.allDepartments");
        },
        hideModal() {
            this.isModalShow = false;
        },
        edit(user) {
            this.selectedUser = user;
            const getWorkflow = this.workflows.find((workflow) => workflow.id === this.details.workflowId);

            this.form.permissions.deleteTask = getWorkflow.permissions.deleteTask.slice();
            this.form.permissions.editTask = getWorkflow.permissions.editTask.slice();
            this.form.permissions.createTask = getWorkflow.permissions.createTask.slice();
            this.form.permissions.draggingTask = getWorkflow.permissions.draggingTask.slice();

            console.log("Updated form permissions:", this.form.permissions);
            this.isModalShow = true;
        },

        handleSave() {
            console.log("Emitting update-form with:", this.form.permissions);
            this.$emit("update-form", this.form.permissions);
            this.hideModal();
        },

        togglePermission(permissionType, userId) {
            console.log("Toggle Permission:", permissionType, userId);
            const index = this.form.permissions[permissionType].indexOf(userId);
            if (index > -1) {
                this.form.permissions[permissionType].splice(index, 1);
            } else {
                this.form.permissions[permissionType].push(userId);
            }
            console.log("Updated Permissions:", this.form.permissions);
        },

        debouncedGet(getRoles = false, showLoading = true, interval = 2000) {
            if (this.getTimerId) clearTimeout(this.getTimerId);
            this.getTimerId = setTimeout(() => {
                this.get(getRoles, showLoading);
            }, interval);
        },
        get(getRoles = false, showLoading = true) {
            if (showLoading) this.isBusy = true;
            const query = this.searchText === "" && this.searchText == null ? undefined : this.searchText;
            const pagination = { perPage: this.paginationCursor.perPage, page: this.paginationCursor.page };
            const sorting = {
                sortBy: this.currentSort.columnKey,
                sortOrder: this.currentSort.order,
            };

            this.getUsers({
                perPage: pagination.perPage,
                page: pagination.page,
                query,
                sortBy: sorting.sortBy,
                sortOrder: sorting.sortOrder,
                updateStore: false,
            })
                .then((x) => {
                    if (!_.isEqual(this.users, x.data)) {
                        this.users = x.data;
                        this.paginationCursor.total = x.data.total;
                    }

                    if (getRoles) {
                        this.getRoles({ perPage: 100, page: 1 });
                    }
                })
                .finally(() => {
                    if (showLoading) this.isBusy = false;
                    this.lastFetchTS = Date.now();
                });
            this.getActiveUserCount();
        },
        mounted() {
            this.form = this.workflows.find((workflow) => workflow.id === this.details.workflowId);
            this.get(true);
            this.timerId = setInterval(() => {
                const tookTime = Date.now() - this.lastFetchTS;
                if (tookTime > 5000) {
                    this.debouncedGet(false, false, 0);
                }
            }, 5000);
        },
        beforeDestroy() {
            if (this.timerId) clearInterval(this.timerId);
        },
        updated() {
            if (this.$validator.locale !== this.$i18n.locale) this.$validator.localize(this.$i18n.locale);
        },
    },
    watch: {
        paginationCursor: {
            deep: true,
            handler(newVal, oldVal) {
                this.debouncedGet(false, true, 1);
            },
            $route() {
                this.queryCreateCheck();
            },
        },
        searchText(newValue, oldValue) {
            this.debouncedGet();
        },
        currentSort(newValue, oldValue) {
            if (newValue) {
                this.debouncedGet(false, true, 0);
            }
        },
        selectedDepartments(newValue) {
            this.user.subjects = newValue.map((x) => x.value);
        },
    },
};

</script>
<style lang="scss" scoped>
#workflow-permission {
    overflow: scroll;
    height: 650px;
    .permissions-container {
        padding: 20px;
    }

    .modal2 {
        width: 400px !important;
    }

    .username {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
    }

    .checkbox-group {
        flex-direction: column;
        display: grid;
        gap: 10px;
    }

    .checkbox-group label {
        display: flex;
        align-items: center;
        font-size: 16px;
        padding: 5px 0;
    }

    .checkbox-group input[type="checkbox"] {
        margin-right: 10px;
        accent-color: #1e88e5;
    }
}
</style>

